import * as React from 'react'

type Scalar = boolean | number | string | bigint | null | undefined

export function useEffect(effect: React.EffectCallback, deps: Scalar[]) {
  React.useEffect(effect, deps) // eslint-disable-line react-hooks/exhaustive-deps
}

export function useUnsafeEffect(
  effect: React.EffectCallback,
  deps?: React.DependencyList | undefined
) {
  React.useEffect(effect, deps) // eslint-disable-line react-hooks/exhaustive-deps
}
